import React from "react"
import PropTypes from "prop-types"
import { message } from 'antd'
import Screen from '../../Components/Screen'
import Header from "./Components/Header"
import StatsBar from "./Components/StatsBar"
import SettingsPanel from "./Components/SettingsPanel"
import ActiveRamsTable from "./Components/ActiveRamsTable"
import DocumentsModal from "./Components/DocumentsModal"
import NewRunModal from "./Components/NewRunModal"
import RamsRecordModal from '../../Modals/RamsRecord'
import { getProject } from '../../HttpRequests/projects'

export default class _RamsControlCentre_ extends React.PureComponent {

  static propTypes = {
    componentDidMount: PropTypes.func.isRequired,
    dashboard: PropTypes.object.isRequired,
    dashboardLoading: PropTypes.bool.isRequired,
    activeRams: PropTypes.array.isRequired,
    activeRamsLoading: PropTypes.bool.isRequired,
    pagination: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    settingsLoading: PropTypes.bool.isRequired,
    projectsList: PropTypes.array.isRequired,
    serviceTypes: PropTypes.array.isRequired,
    userSettings: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    documents: PropTypes.array,
    documentsLoading: PropTypes.bool,
    documentsUploading: PropTypes.bool,
    onChangeTable: PropTypes.func.isRequired,
    onProjectFilterChange: PropTypes.func.isRequired,
    onStatusFilterChange: PropTypes.func.isRequired,
    onRefreshActive: PropTypes.func.isRequired,
    onClickSettings: PropTypes.func.isRequired,
    onFetchDocuments: PropTypes.func.isRequired,
    onUploadDocument: PropTypes.func.isRequired,
    onDeleteDocument: PropTypes.func.isRequired,
    onToggleDocumentActive: PropTypes.func.isRequired,
  }

  state = {
    documentsModalVisible: false,
    newRunModalVisible: false,
    ramsRecordModalVisible: false,
    ramsRecordModalProject: null,
    ramsRecordModalRecordId: null,
  }

  componentDidMount = () => this.props.componentDidMount()

  handleManageDocuments = () => {
    this.setState({ documentsModalVisible: true })
    this.props.onFetchDocuments()
  }

  handleCloseDocumentsModal = () => {
    this.setState({ documentsModalVisible: false })
  }

  handleRefreshDocuments = () => {
    this.props.onFetchDocuments()
  }

  handleNewRun = () => {
    this.setState({ newRunModalVisible: true })
  }

  handleCloseNewRunModal = () => {
    this.setState({ newRunModalVisible: false })
  }

  handleRunCreated = () => {
    this.props.onRefreshActive()
  }

  handleClickRecord = async (record) => {
    var projectId = record.project && record.project.id
    if (!projectId) {
      message.error('No project associated with this RAMS record')
      return
    }
    try {
      var params = {
        include: [
          'clientSite',
          'clientSite.client',
          'clientSite.client.clientContacts',
          'clientContact',
        ].join(),
      }
      var response = await getProject({ id: projectId, params: params })
      var project = response.data.data
      this.setState({
        ramsRecordModalVisible: true,
        ramsRecordModalProject: project,
        ramsRecordModalRecordId: record.id,
      })
    } catch (err) {
      message.error('Failed to load project details')
    }
  }

  handleCloseRamsRecordModal = () => {
    this.setState({
      ramsRecordModalVisible: false,
      ramsRecordModalProject: null,
      ramsRecordModalRecordId: null,
    }, function() {
      this.props.onRefreshActive()
    }.bind(this))
  }

  render () {
    var {
      dashboard,
      dashboardLoading,
      activeRams,
      activeRamsLoading,
      pagination,
      settings,
      settingsLoading,
      projectsList,
      serviceTypes,
      userSettings,
      documents,
      documentsLoading,
      documentsUploading,
      onChangeTable,
      onProjectFilterChange,
      onStatusFilterChange,
      onRefreshActive,
      onClickSettings,
      onUploadDocument,
      onDeleteDocument,
      onToggleDocumentActive,
    } = this.props

    var {
      documentsModalVisible,
      newRunModalVisible,
      ramsRecordModalVisible,
      ramsRecordModalProject,
      ramsRecordModalRecordId,
    } = this.state

    return (

      <Screen>

        <Header
          onClickManageDocuments={this.handleManageDocuments}
          onClickSettings={onClickSettings}
          onClickRefresh={onRefreshActive}
          onClickNewRun={this.handleNewRun}
        />

        <SettingsPanel
          settings={settings}
          loading={settingsLoading}
        />

        <StatsBar
          dashboard={dashboard}
          loading={dashboardLoading}
        />

        <ActiveRamsTable
          data={activeRams}
          fetching={activeRamsLoading}
          pagination={pagination}
          projectsList={projectsList}
          onChangeTable={onChangeTable}
          onProjectFilterChange={onProjectFilterChange}
          onStatusFilterChange={onStatusFilterChange}
          onClickRecord={this.handleClickRecord}
        />

        <DocumentsModal
          visible={documentsModalVisible}
          onClose={this.handleCloseDocumentsModal}
          documents={documents || []}
          serviceTypes={serviceTypes || []}
          userSettings={userSettings || {}}
          loading={documentsLoading}
          uploading={documentsUploading}
          onUpload={onUploadDocument}
          onDelete={onDeleteDocument}
          onToggleActive={onToggleDocumentActive}
          onRefresh={this.handleRefreshDocuments}
        />

        <NewRunModal
          visible={newRunModalVisible}
          onClose={this.handleCloseNewRunModal}
          onRunCreated={this.handleRunCreated}
        />

        {ramsRecordModalVisible && ramsRecordModalProject && (
          <RamsRecordModal
            onClose={this.handleCloseRamsRecordModal}
            projectId={ramsRecordModalProject.id}
            project={ramsRecordModalProject}
            ramsRecordId={ramsRecordModalRecordId}
          />
        )}

      </Screen>

    )
  }
}
